import { render } from "./CLOUD.vue?vue&type=template&id=2c319334"
import script from "./CLOUD.vue?vue&type=script&lang=js"
export * from "./CLOUD.vue?vue&type=script&lang=js"
script.render = render

export default script